// extracted by mini-css-extract-plugin
module.exports = {"small":"EmployerName_small__2HTJn","grade":"EmployerName_grade__2ExG0"};